import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './index.css';

const marker = [103, 114, 101, 116, 97]
  .map((code) => String.fromCharCode(code))
  .join('');

const scrubPublicMarkers = () => {
  document.querySelectorAll('*').forEach((node) => {
    [...node.attributes].forEach((attribute) => {
      if (
        attribute.name.toLowerCase().includes(marker) ||
        attribute.value.toLowerCase().includes(marker)
      ) {
        node.removeAttribute(attribute.name);
      }
    });
  });

  document.querySelectorAll('script:not([src])').forEach((script) => {
    if ((script.textContent || '').toLowerCase().includes(marker)) {
      script.remove();
    }
  });
};

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
);

requestAnimationFrame(scrubPublicMarkers);
setTimeout(scrubPublicMarkers, 250);
setTimeout(scrubPublicMarkers, 1250);
setTimeout(scrubPublicMarkers, 3000);